// FILE: src/components/UpgradeModal.jsx
import React from "react";
import { useNavigate } from "react-router-dom";

const FEATURE_LABELS = {
  documents: "documents",
  messages: "personal messages",
  funeralPlanning: "funeral planning entries",
  passwordVault: "password entries",
  accountManagers: "account managers",
};

export default function UpgradeModal({ isOpen, onClose, feature }) {
  const navigate = useNavigate();
  if (!isOpen) return null;

  const label = FEATURE_LABELS[feature] || "entries";

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 9999, padding: 20,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff", borderRadius: 20, padding: 32,
          maxWidth: 460, width: "100%",
          boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
          textAlign: "center",
        }}
      >
        {/* Icon */}
        <div style={{
          width: 56, height: 56, borderRadius: "50%",
          background: "#fff0ee", border: "2px solid #f15822",
          display: "flex", alignItems: "center", justifyContent: "center",
          margin: "0 auto 16px", fontSize: 24,
        }}>
          🔓
        </div>

        <h2 style={{ margin: "0 0 10px", fontSize: 22, fontWeight: 900, color: "#2a0516" }}>
          You've used your free entry
        </h2>

        <p style={{ margin: "0 0 8px", color: "#4b5563", fontSize: 15, lineHeight: 1.6 }}>
          Upgrade to add unlimited {label}, messages, wishes and more.
        </p>

        <p style={{ margin: "0 0 24px", color: "#f15822", fontWeight: 700, fontSize: 14 }}>
          From &euro;49.99/year - less than &euro;1 a week
        </p>

        {/* Trust signals */}
        <div style={{ display: "flex", justifyContent: "center", gap: 16, marginBottom: 24, flexWrap: "wrap" }}>
          {["14-day money back", "Cancel anytime", "Secure checkout"].map((t, i) => (
            <span key={i} style={{ fontSize: 11, color: "#6b7280" }}>{t}</span>
          ))}
        </div>

        {/* Buttons */}
        <button
          onClick={() => navigate("/personal/plans")}
          style={{
            width: "100%", height: 48, borderRadius: 12, border: "none",
            background: "#980000", color: "#fff", fontWeight: 800, fontSize: 16,
            cursor: "pointer", marginBottom: 12,
            boxShadow: "0 4px 14px rgba(152,0,0,0.20)",
          }}
        >
          See plans &rarr;
        </button>

        <button
          onClick={onClose}
          style={{
            width: "100%", height: 44, borderRadius: 12,
            border: "1px solid #e5e7eb", background: "#fff",
            color: "#6b7280", fontWeight: 600, fontSize: 14, cursor: "pointer",
          }}
        >
          Continue with free plan
        </button>
      </div>
    </div>
  );
}
